<script>
import { getOpeningsUrl } from '@/data/openings'

export default {
    
    props: {
        text: {
            type: String,
            default: 'View Openings'
        },
        className: {
            type: String,
            default: 'button--white'
        },
    },
    
    computed: {
        stored() {
            const { eContentLink, eContentLabel } = this.$store.getters
            const { user: { type }} = this.$store.state
            
            return { type, eContentLink, eContentLabel }
        },
    },
    
    render(h) {
        const { stored } = this

        return h('a', {
            class: `button ${this.className}`,
            domProps: {
                target: '_blank',
                href: getOpeningsUrl(stored.type)
            }
        }, this.text)
    }
}
</script>